// TKTK ALWAYS CHANGE TO MATCH PRODUCTION
function isLandingPage(pathname) {
  if ( pathname === "/" || pathname === "/investigations/india-shrimp-a-growing-goliath/") {
    return true;
  }
  return false;
}

export default isLandingPage;